// 共通
export const MSG_ERR_UNEXPECTED = "予期せぬエラーが発生しました。";
export const MSG_CONFIRM_INPUT_CHANGE_NOT_UPDATED = "入力情報が変更されています。\n更新せずに画面を移りますが、よろしいでしょうか?"

// ログイン画面
export const MSG_ERR_LOGIN_INFO_NOT_ENTERED = "ログインIDまたはパスワードが未入力です";
export const MSG_ERR_LOGIN = "ログインIDまたはパスワードが正しくありません";

// 基本価格表・市況価格表　共通
export const MSG_ERR_SHIPPING_DATE_NOT_ENTERED = "出荷日を入力してください。";
export const MSG_ERR_SHIPPING_DATE_NOT_FOUND = "次月末までに開場日が見つかりませんでした。手動で出荷日を設定してください。";

// 基本価格表編集画面
export const MSG_ERR_BASIC_PRICE_INCORRECT = "基本価格の入力に誤りの箇所があります。";

// 市況価格表編集画面
export const MSG_ERR_MARKET_PRICE_INCORRECT = "市況価格の入力に誤りの箇所があります。";

// 商品登録画面・商品マスタ追加ダイアログ　共通
export const MSG_ERR_DUPLICATED_PRODUCT_ID = "商品IDが重複しています。商品IDを変更してください。";